import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { TitleFirstLine } from './styles';

/**
 * DynamicTitle component that displays a title with animated words.
 *
 * This component takes a title string and an array of words, displaying them one at a time
 * with a specified interval. The title can be split into multiple sentences using the
 * '{{SENTENCES}}' delimiter. The component also measures the width of the words for smooth
 * animations.
 * @param {string} props.title - The title string to be displayed, which can include
 *                               '{{SENTENCES}}' to split into multiple sentences.
 * @param {Array<string>} props.words - An array of words to be animated.
 */
export default function DynamicTitle({ title, words, interval = 3000 }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, interval);

    return () => clearInterval(timer);
  }, [interval, words.length]);

  return (
    <>
      <TitleFirstLine>
        {title.split('{{SENTENCES}}')[0]}
        <AnimatePresence mode="wait" initial={false} exit="exit">
          <motion.div
            key={currentIndex}
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -20, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <b>{words[currentIndex]}</b>
          </motion.div>
        </AnimatePresence>
      </TitleFirstLine>
      {title.split('{{SENTENCES}}')[1]}
    </>
  );
}
